import { IBuilder, Builder } from 'builder-pattern';
import { CardDisplayType } from '../../types';
import { DEFAULT_CARD_DISPLAY_TYPE } from 'src/app/modules/game/services/card-display-type.service';

/** how fast the computer opponents play in training (pause before each of their moves) */
export type BotSpeed = 'slow' | 'normal' | 'fast';

export const BOT_SPEEDS: BotSpeed[] = ['slow', 'normal', 'fast'];
export const DEFAULT_BOT_SPEED: BotSpeed = 'normal';

export const BOT_SPEED_LABELS: Record<BotSpeed, string> = {
  slow: 'Gemütlich',
  normal: 'Normal',
  fast: 'Schnell',
};

export function isBotSpeed(value: unknown): value is BotSpeed {
  return BOT_SPEEDS.includes(value as BotSpeed);
}

export interface SettingsInterface {
  androidDeviceID?: string;
  hasActivePremiumSubscription: boolean;
  cardDisplayType: CardDisplayType;
  sfxSoundsEnabled: boolean;
  speechSoundsEnabled: boolean;
  musicEnabled: boolean;
  notificationsEnabled: boolean;
  vibrationEnabled: boolean;
  keepChatFocused: boolean;
  blockGuests: boolean;
  botSpeed: BotSpeed;
}

export namespace SettingsInterface {
  export function builder(
    template?: Partial<SettingsInterface>
  ): IBuilder<SettingsInterface> {
    return Builder<SettingsInterface>(template)
      .androidDeviceID(template?.androidDeviceID)
      .hasActivePremiumSubscription(
        template?.hasActivePremiumSubscription ?? false
      )
      .cardDisplayType(template?.cardDisplayType ?? DEFAULT_CARD_DISPLAY_TYPE)
      .sfxSoundsEnabled(template?.sfxSoundsEnabled ?? true)
      .speechSoundsEnabled(template?.speechSoundsEnabled ?? true)
      .musicEnabled(template?.musicEnabled ?? true)
      .notificationsEnabled(template?.notificationsEnabled ?? true)
      .vibrationEnabled(template?.vibrationEnabled ?? true)
      .keepChatFocused(template?.keepChatFocused ?? false)
      .blockGuests(template?.blockGuests ?? false)
      .botSpeed(template?.botSpeed ?? DEFAULT_BOT_SPEED);
  }
}
